

import { Session as SessionDTO } from "app/models/session";
import { initRol } from "app/models/rolmap";
import * as kea from "kea-react"
import { rpcController } from "../rpc";
import { cacheResource, observeResource, addOnInvalidateHandler, invalidateResource, } from "kea-resource";
import { Rol } from "app/resources/simple";
import { Session } from "./session";
const headerName = "Authorization";
const controller = rpcController("Login");

/**Obtiene el id del usuario actual. No utilice este Id para obtener información de los permisos o para mostrar o no
 * partes de la UI, para esto utilice el PermisosRx
 */
async function getIdUsuario(): Promise<number | null> {
    const token = Session.getToken();
    return token && token.idUsuario;
}

/**Obtiene el usuario actual o null */
async function tryGetUser(): Promise<SessionDTO> {
    try {
        const ret: SessionDTO = await controller("GetSession", {});
        return {
            ...ret,
            Permisos: initRol(ret.Permisos)
        };
    } catch (error) {
        //Si este metodo del controlador lanza error lo mas probable es que el token sea inválido o que haya expirado
        throw new Error("No hay conexión con el servidor, recargue la página");
    }
}


/**Dado un usuario y contraseña trata de obtener un token de autenticación del servidor, si no se puede devuelve undefined*/
async function tryGetTokenFromUser(user: string, password: string): Promise<string | undefined> {
    try {
        return await controller("Login", { user, password });
    } catch (error) {
        return undefined;
    }
}


/**Intenta hacer login y devuelve true si se realizó el login y se estableció el token correctamente, false si no se pudo realizar el login */
async function login(user: string, password: string): Promise<boolean> {
    const token = await tryGetTokenFromUser(user, password);
    if (token) {
        //Login correcto :)
        Session.set(token);
        return true;
    }
    return false;
}



const cached = cacheResource(
    {
        tryGetUser,
        tryGetTokenFromUser,
        login,
        getIdUsuario
    },
    {
        tryGetUser: true,
        getIdUsuario: true,
    }, {
        login: true,
    }
);

const SessionRx = observeResource(cached.tryGetUser);
const IdSucursalRx = SessionRx.filter(x => !!x).map(x => x && x.IdSucursal);
const PermisoRx = SessionRx.map(x => x.Permisos);

export const User = ({ ...cached, SessionRx, IdSucursalRx, PermisoRx });
addOnInvalidateHandler(Rol, () => invalidateResource(cached));

addOnInvalidateHandler(Session, () => invalidateResource(cached));
addOnInvalidateHandler(cached, () => invalidateResource(Session));


// WEBPACK FOOTER //
// ./app/resources/items/user.ts